import { FC, ReactElement } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import {
  ContentWidth,
  TextWidth,
  TextWidthExtended,
} from '@ta-interaktiv/react-disco-grid'
import MapSection from '../MapSection'
import { RankingTable } from 'components/ranking-table'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]

  return (
    <AppContainer className={globalClasses.join(' ')}>
      <MapSection
        bfsIdParamName={tenant?.lang === 'fr' ? 'commune' : 'gemeinde'}
        locale={tenant?.lang ?? 'de'}
      />
    </AppContainer>
  )
}
const AppContainer = styled.div`
  font-family: var(--font-noto);
  font-size: 1.8rem;
  line-height: 3rem;
  background-color: var(--section-background);
  padding: 2rem 1rem;
  margin-bottom: 3rem;
  overflow: hidden;
`
export default MainComponent
